(function () {

    "use strict";

    var dependencies = ['$q', 'tagsDataService'];

    function AssignTagsForm(formName) {
        var self = this;
        var tagsDataService = dependencies['tagsDataService'];
        var $q = dependencies.$q;
        var modeToIndex = [];
        var allModesTagsCopy = [];

        var init = function () {
            self.isLoading = true;
            self.isEdit = false;
            self.data = {};
            self.tagsModes = tagsDataService.TAGS_TYPES;
            self.tagsText = tagsDataService.TAGS_TYPES_TO_TEXT;
            self.selectedTags = [];
        };

        init();

        self.loadData = function (modalData) {
            self.candidates = modalData.candidates;
            var tagsGroupedByMode = angular.copy(modalData.tags);

            self.allModesTags = [];
            for (var mode in tagsGroupedByMode) {
                if (!['STATUS', 'GENERAL', 'POSITION', 'SILVER_MEDALIST'].includes(mode)) {
                    var modeTags = tagsGroupedByMode[mode];
                    if (!_.isEmpty(modeTags)) {
                        var tempObj = {};
                        tempObj.mode = tagsDataService.getTagGroup(modeTags[0]);
                        tempObj.tags = modeTags;
                        modeToIndex.push(tempObj.mode);
                        self.allModesTags.push(tempObj);
                    }
                }
            }
            allModesTagsCopy = angular.copy(self.allModesTags);
            self.isLoading = false;
        };


        self.isTagsAvailable = function(){
            for( var group in self.allModesTags){
                if(self.allModesTags[group].tags.length > 0){
                    return true;
                }
            }
            return false;
        };

        self.selectTag = function (tag, $index) {
            self.selectedTags.push(tag);
            self.allModesTags[modeToIndex.indexOf(tagsDataService.getTagGroup(tag))].tags.splice($index, 1);
        };

        self.unselectTag = function (tag, $index) {
            self.allModesTags[modeToIndex.indexOf(tagsDataService.getTagGroup(tag))].tags.push(tag);
            self.selectedTags.splice($index, 1);
        };

        self.clearAll = function () {
            self.allModesTags = angular.copy(allModesTagsCopy);
            self.selectedTags = [];
        };

        self.setBrandId = function (_brandId) {
            self.brandId = _brandId;
        };

        self.save = function (candidatesIds, tags) {
            var defer = $q.defer();

            self.isLoading = true;
            tagsDataService.assignTagsToCandidates(self.brandId, candidatesIds, tags, 'SEARCH')
                .then(function (res) {
                    defer.resolve(res);
                })
                .catch(function (err) {
                    if (err?.message === BrandAPI.PROFILE_TYPES_ERROR_CODES.CANNOT_APPLY) {
                        let text = candidatesIds.length === 1 ? self.candidates[0].fullName + ' ' + $filter("translate")("has an employment profile under your account, please add their profile directly to the talent pool instead.") : $filter("translate")("Some of the selected candidates already have an employment profile under your account, please add their profile directly to the talent pool instead.")
                        hAlert({
                            title: $filter("translate")("Error"),
                            text: text,
                        });
                    } else {
                        defer.reject(err);
                    }
                })
                .finally(function () {
                    self.isLoading = false;
                });

            return defer.promise;

        };

        self.destroy = function () {
            self.data = {};
            self.isLoading = false;
        };
    }

    angular
        .module("harriApp")
        .run(['hFormsService', function (hFormsService) {

            hFormsService.registerForm("AssignTagsForm", {
                form: AssignTagsForm,
                dependencies: dependencies
            });
        }]);
})();
